<template>
    <div class="pages" :class="{ 'is-h5': isH5 }">
        <!-- 顶部信息 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <!-- 面包屑 -->
        <div class="breadcrumb">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $t('专题详情') }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 详情 -->
        <div class="detail" :class="{ 'is-h5': isH5 }">
            <div class="detail-tit">{{ detali.title }}</div>
            <div class="operate">
                <div class="operate-box pointer" @click="onPraise">
                    <p>{{ $t("赞") }}</p>
                    <img src="../../../../static/images/icon/icon39.png" alt="" v-if="detali.is_zan">
                    <img src="../../../../static/images/icon/icon42.png" alt="" v-else>
                </div>
                <div class="operate-box pointer" @click="onTrample">
                    <p>{{ $t("踩") }}</p>
                    <img src="../../../../static/images/icon/icon51.png" alt="" v-if="detali.is_cai">
                    <img src="../../../../static/images/icon/icon43.png" alt="" v-else>
                </div>
                <div class="operate-box">
                    <p>{{ $t("评论") }}</p>
                    <img src="../../../../static/images/icon/icon44.png" alt="">
                </div>
            </div>
            <div v-html="decodedRichText" class="detail-html"></div>
        </div>

        <div class="comment" :class="{ 'is-h5': isH5 }">
            <div class="comment-tit">{{ $t("评论") }}</div>

            <div class="comment-textarea">
                <textarea placeholder="请输入" v-model="content"></textarea>
                <div @click="onEvaluate()">{{ $t("发表评论") }}</div>
            </div>

            <div class="comment-list">
                <div class="comment-list-box" v-for="(item, index) in evaluate_list" :key="index">
                    <img :src="item.user_avatar" alt="">
                    <div class="comment-list-box-r">
                        <div class="comment-list-box-rt">
                            <div class="comment-list-box-rtl">{{ item.user_nickname }}</div>
                            <div class="comment-list-box-rtr" v-if="item.user_id == user_info.id">{{ $t("我") }}</div>
                        </div>
                        <div class="comment-list-box-rc">
                            {{ item.content }}
                        </div>
                        <div class="comment-list-box-rb">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>

            <div class="comment-pagination justify-center">
                <el-pagination layout="prev, pager, next" :page-size="page_size" :total="total" background
                    :small="isH5" @current-change="onCurrentChange"></el-pagination>
            </div>
        </div>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
    import ShortcutBar from '@/components/ShortcutBar';
    import leftSuspension from "@/components/leftSuspension.vue";
    import { dynamicDetail, dynamicEvaluateList, dynamicEvaluate, dynamicTrample, dynamicPraise } from '@/api/user';
    import he from 'he';
    import footerBar from '@/components/footerBar';

    export default {
        components: {
            'footer-bar': footerBar,
            'shortcut-bar': ShortcutBar,
            leftSuspension,
        },
        data() {
            return {
                richTextContent: '',
                detali: {},
                evaluate_list: [],//评价列表
                content: '',//评价内容
                dynamics_id: '',//动态id
                user_info: {},//用户信息

                page_size: 0,//单页数量
                total: 0,//订单总数
                page: 1,//页数
                isH5: typeof window !== 'undefined' && window.innerWidth < 768,
            };
        },
        mounted() {
            this.updateIsH5();
            window.addEventListener('resize', this.updateIsH5);
            this.dynamics_id = this.$route.params.id;
            this.onDynamicDetail(this.$route.params.id);
            this.onEvaluateList(this.$route.params.id);
            let user_info = JSON.parse(this.$cookies.get('user_info'))
            this.user_info = user_info
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateIsH5);
        },
        computed: {
            decodedRichText() {
                // 解码HTML实体
                return he.decode(this.richTextContent);
            }
        },
        methods: {
            updateIsH5() {
                this.isH5 = window.innerWidth < 768;
            },
            onCurrentChange(e) {
                this.page = e
                this.onEvaluateList(this.dynamics_id);
            },
            /**踩 */
            onTrample() {
                this.detali.is_cai = this.detali.is_cai == 0 ? 1 : 0;
                this.detali.is_zan = 0;
                dynamicTrample({ id: this.dynamics_id }).then(res => { })
            },
            /**赞 */
            onPraise() {
                this.detali.is_zan = this.detali.is_zan == 0 ? 1 : 0;
                this.detali.is_cai = 0;
                dynamicPraise({ id: this.dynamics_id }).then(res => { })
            },
            /**发表评价 */
            onEvaluate() {
                if (!this.content) {
                    this.$message.warning(this.$t('请输入评价内容'));
                    return
                }
                let data = {
                    dynamics_id: this.dynamics_id,
                    content: this.content
                }
                dynamicEvaluate(data).then(res => {
                    if (res.code == 1) {
                        console.log(res);
                        this.content = ''
                        this.$message.success('发布成功');
                        this.onEvaluateList(this.dynamics_id);
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            },
            /**动态评价列表 */
            onEvaluateList(id) {
                let data = {
                    id: id,
                    page: this.page
                }
                dynamicEvaluateList(data).then(res => {
                    // console.log(res.data.data)
                    this.page_size = res.data.per_page
                    this.total = res.data.total
                    let data = res.data.data
                    this.evaluate_list = data
                })
            },
            /**动态详情 */
            onDynamicDetail(id) {
                dynamicDetail({ id: id }).then(res => {
                    this.richTextContent = res.data.content
                    this.detali = res.data
                })
            }
        }
    };
</script>

<style scoped lang="scss">
    .page-header {
        z-index: 999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }

    .page-header-placeholder {
        height: 56px;
    }

    .breadcrumb {
        padding: 24px var(--page-gutter) 32px;
    }

    .detail {
        padding: 0 var(--page-gutter-wide);
        min-height: 80vh;

        .detail-tit {
            font-size: 32px;
            color: #333333;
            margin-bottom: 16px;
            text-align: center;
        }
    }

    .operate {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 32px;

        .operate-box {
            display: flex;
            align-items: center;
            margin-left: 25px;

            p {
                margin-right: 10px;
                font-size: 16px;
                color: #666666;
            }

            img {
                width: 22px;
                height: 22px;
            }
        }

        .operate-box:nth-child(1) {
            margin-left: 0;
        }
    }

    .comment {
        margin-top: 56px;
        padding: 0 360px 56px;

        .comment-tit {
            font-size: 20px;
            padding-bottom: 24px;
        }

        .comment-textarea {
            width: 100%;
            height: 100px;
            background: #F8F8F8;
            border-radius: 8px;
            display: flex;
            align-items: end;

            /* // justify-content: space-between; */
            textarea {
                width: calc(100% - 84px);
                height: 100px;
                background: #F8F8F8;
                padding: 16px;
                font-size: 16px;
                resize: none;
            }

            div {
                width: 72px;
                height: 32px;
                background: #000000;
                border-radius: 8px 8px 8px 8px;
                line-height: 32px;
                color: #FFFFFF;
                font-size: 14px;
                text-align: center;
                margin-bottom: 12px;
                cursor: pointer;
            }
        }

        .comment-list {
            padding-top: 8px;

            .comment-list-box {
                padding: 24px 0;
                border-bottom: 1px solid #CCCCCC;
                display: flex;

                img {
                    width: 36px;
                    height: 36px;
                    border-radius: 50px;
                }

                .comment-list-box-r {
                    padding-left: 16px;

                    .comment-list-box-rt {
                        display: flex;
                        align-items: center;

                        .comment-list-box-rtl {
                            font-size: 14px;
                            color: #000000;
                            font-weight: 500;
                        }

                        .comment-list-box-rtr {
                            color: #FFFFFF;
                            font-size: 12px;
                            padding: 2px 4px;
                            background: #000000;
                            border-radius: 4px;
                            margin-left: 8px;
                        }
                    }

                    .comment-list-box-rc {
                        margin: 8px 0;
                        font-size: 14px;
                        color: #666666;
                    }

                    .comment-list-box-rb {
                        font-size: 14px;
                        color: #999999;
                    }
                }
            }

            .comment-list-box:last-child {
                border-bottom: none;
            }
        }

        .comment-pagination {
            padding-top: 32px;
        }
    }

    /* PC 端专题内容区与简介页保持一致，固定使用 1024px 页面栅格。 */
    @media (min-width: 768px) {
        .breadcrumb,
        .detail,
        .comment {
            width: 1024px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }

        .breadcrumb {
            padding: 24px 0 32px;
        }

        .detail {
            padding: 0;
        }

        .comment {
            margin-top: 56px;
            padding: 0 0 56px;
        }
    }

    @media (max-width: 767px) {
        .pages.is-h5 {
            overflow-x: hidden;
            width: 100%;
            background: #f5f6f8;
        }

        .page-header {
            padding-top: env(safe-area-inset-top, 0px);
        }

        .page-header-placeholder {
            height: calc(56px + env(safe-area-inset-top, 0px));
        }

        .pc-float {
            display: none;
        }

        .breadcrumb {
            padding: 10px 12px 12px;
            overflow-x: auto;
            white-space: nowrap;
            font-size: 12px;
        }

        .detail.is-h5 {
            padding: 0 12px;
            min-height: auto;

            .detail-tit {
                font-size: 20px;
                line-height: 1.4;
                margin-bottom: 12px;
                text-align: left;
            }

            .operate {
                margin-bottom: 16px;
                flex-wrap: wrap;
                gap: 12px;

                .operate-box {
                    margin-left: 0;

                    p {
                        font-size: 14px;
                        margin-right: 6px;
                    }

                    img {
                        width: 20px;
                        height: 20px;
                    }
                }
            }

            .detail-html {
                background: #fff;
                border-radius: 8px;
                padding: 12px;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.6;
                word-break: break-word;

                /deep/ img {
                    /* 富文本内联宽高可能不成比例，移动端以原始比例缩放。 */
                    max-width: 100% !important;
                    height: auto !important;
                    object-fit: contain;
                }

                /deep/ video {
                    max-width: 100%;
                }
            }
        }

        .comment.is-h5 {
            margin-top: 12px;
            padding: 0 12px 24px;

            .comment-tit {
                font-size: 16px;
                padding-bottom: 12px;
            }

            .comment-textarea {
                height: auto;
                flex-direction: column;
                align-items: stretch;
                padding: 12px;
                box-sizing: border-box;
                background: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

                textarea {
                    width: 100%;
                    height: 80px;
                    padding: 0;
                    font-size: 14px;
                    margin-bottom: 10px;
                    background: #fff;
                }

                div {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    margin-bottom: 0;
                    border-radius: 8px;
                }
            }

            .comment-list {
                margin-top: 24px;
                padding-top: 0;
                background: #fff;
                border-radius: 8px;
                padding: 0 12px;
                box-sizing: border-box;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

                .comment-list-box {
                    padding: 14px 0;

                    img {
                        width: 40px;
                        height: 40px;
                        flex-shrink: 0;
                    }

                    .comment-list-box-r {
                        flex: 1;
                        min-width: 0;
                        padding-left: 12px;

                        .comment-list-box-rc {
                            word-break: break-all;
                            line-height: 1.5;
                            font-size: 13px;
                        }

                        .comment-list-box-rb {
                            font-size: 12px;
                        }
                    }
                }
            }

            .comment-pagination {
                padding-top: 16px;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                display: flex;
                justify-content: center;
                width: 100%;

                /deep/ .el-pagination {
                    margin: 0 auto;
                    justify-content: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/home/components/TopicDetalis.vue